<template>
  <div class="users">
    <!-- <TRegister v-if="newUser" @closeModal="newUser=false"/> -->
    <BusinessModal
      v-if="businessActive"
      :item="$store.state.business.newBusiness"
      @rellena-empresa="updateBusiness($event)"
      @closeModal="businessActive = false"
      @clear="clearBusiness"
    ></BusinessModal>
    <BusinessModalDelete
      v-if="businessDeleteActive"
      @closeModal="businessDeleteActive = false"
      :businessId="businessIdDel"
    ></BusinessModalDelete>
    <div class="users__header">
      <div class="users__first">
        Empresas
        <button class="users__header-button" @click="businessActive = true">
          Agregar empresa
        </button>
      </div>
      <div class="users__search">
        <i class="icon-search"></i>
        <input type="text" placeholder="Buscar empleado..." />
      </div>
    </div>

    <div class="users__body" v-if="!!$store.state.business.businessList">
      <div
        class="container"
        v-for="(item, index) in $store.state.business.businessList"
        :key="index"
      >
        <div class="container__body">
          <div class="container__img">
            <img :src="require('@/assets/img/building.svg')" alt />
          </div>
          <div class="container__datos">
            <div class="container__datos-nombres" @click="business(index)">
              {{ item.name }}
            </div>
            <div class="container__datos-cargo">
              <i>{{ item.ruc }}</i>
            </div>
            <div class="container__datos-fono">
              <i>{{ item.type | typeBusiness }}</i>
            </div>
          </div>
          <div class="container__tools">
            <i class="icon-edit" @click="business(index)"></i>
            <i class="icon-close" @click="deleteBusiness(item.id)"></i>
          </div>
        </div>
        <div class="container__footer">
          <i class="icon-phone"></i>
          <i class="icon-mail"></i>
        </div>

        <BusinessModal
          v-if="showBusiness == index"
          @rellena-empresa="updateBusiness($event)"
          :item="item"
          @closeModal="closeModal"
          :edit="isEdit"
        />
      </div>
    </div>
    <div class="nodata-content" v-else>
      <img src="../assets/img/no_data.svg" alt />
      <h5>No hay datos disponibles</h5>
    </div>
    <div class="users__footer">
      <paginate
        v-model="page"
        :pageCount="pages"
        :prev-text="'p'"
        :next-text="'q'"
        :containerClass="'pagination'"
        :page-class="'page-item'"
        :clickHandler="changePages"
      ></paginate>
    </div>
  </div>
</template>

<script>
import BusinessModal from "@/components/business/BusinessModal";
import BusinessModalDelete from "@/components/business/BusinessModalDelete";
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";
export default {
  components: {
    BusinessModal,
    BusinessModalDelete,
    Paginate,
  },

  created() {
    this.$store.dispatch("getBusiness", this.page).then((res) => {
      if (res.status == 200) {
        this.pages = res.data.totalPages;
        this.loading = false;
      }
    });
  },

  data: () => ({
    businessActive: false,
    businessDeleteActive: false,
    showBusiness: null,
    nombres: "jose luis",
    newBusiness: {},
    businessIdDel: null,
    isEdit: false,
    loading: true,
    page: 1,
    pages: 1,
  }),

  filters: {
    firstName(value) {
      if (value.search(" ") != -1) return value.slice(0, value.search(" "));
      else return value;
    },
    typeBusiness(val) {
      console.log(val);

      switch (val) {
        case "micro":
          return "Micro Empresa";
        case "little":
          return "Pequeña Empresa";
        case "middle-macro":
          return "Mediana/Grande Empresa";
      }
    },
  },

  methods: {
    ...mapActions({
      getEmployees: "getEmployees",
    }),
    ...mapGetters({
      listEmploy: "listEmploy",
    }),

    business(index) {
      this.isEdit = true;
      this.showBusiness = index;
    },
    updateBusiness(e) {
      this.newBusiness = { ...this.newBusiness, ...e };
      console.log(this.newBusiness);
    },
    clearBusiness() {
      this.newBusiness = {};
    },
    deleteBusiness(id) {
      console.log(id);

      this.businessIdDel = id;
      this.businessDeleteActive = true;
    },
    closeModal() {
      this.showBusiness = null;
      this.isEdit = false;
    },
    changePages(page) {
      console.log(page);
      this.loading = true;
      this.$store.dispatch("getBusiness", page).then((res) => {
        if (res.status == 200) {
          this.pages = res.data.totalPages;
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.users {
  // height: 100%;
  padding: 1rem 0.5rem;
  background-color: #eceff8;
  // overflow: auto;
  // overflow-y: scroll;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // flex-wrap: wrap;
  @include mq("800px") {
    height: 100%;
  }

  &__header {
    width: 24rem;
    display: flex;
    flex-direction: column;
    @include mq($sm) {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }
    @include mq("800px") {
      width: auto;
      & > * {
        margin: 0.5rem 1.2rem;
      }
    }
    @include mq($md) {
      justify-content: center;
    }

    &-button {
      background-color: $b-emph;
      color: #fff;
      border-radius: 3px;
      padding: 0.5rem 1rem;
    }
  }
  &__first {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include mq("800px") {
      width: 24rem;
    }
  }
  &__search {
    background-color: #fff;
    border-radius: 3px;
    margin-top: 1rem;
    padding-left: 0.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    @include mq("800px") {
      width: 24rem;
      margin-top: 0.5rem;
    }
    .icon-search {
      margin-right: 1rem;
    }
    input::placeholder {
      color: #43425d;
    }
  }

  &__body {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include mq("800px") {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    .container {
      width: 24rem;
      height: 8rem;
      background-color: #fff;
      margin-bottom: 1rem;
      @include mq("800px") {
        margin: 0.6rem 1.2rem;
      }
      &__body {
        height: 75%;
        border-bottom: 1px solid #d7dae2;
        display: flex;
        justify-content: space-between;
        padding: 1rem 1rem 0 1rem;
      }
      &__img {
        height: 3rem;
        width: 3rem;
        border-radius: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
      &__datos {
        // margin-left: -0.5rem;
        min-width: 180px;
        &-nombres {
          font-weight: 700;
          max-width: 200px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          @include mq($lg) {
            cursor: pointer;
          }
        }
        &-cargo {
          display: flex;
          justify-content: space-between;
          color: rgba(#43425d, 0.5);
        }
        &-fono {
          display: flex;
          justify-content: space-between;
          color: rgba(#43425d, 0.5);
        }
      }
      &__tools {
        color: #a4afb7;
        .icon-edit {
          @include mq($lg) {
            cursor: pointer;
          }
        }
        .icon-close {
          margin-left: 0.5rem;
        }
      }
      &__footer {
        height: 25%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          color: #cecfd0;
          font-size: 1.5rem;
          margin: 0 1rem;
        }
      }
    }
  }
}
.nodata-content {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 300px;
    margin: 0 auto;
  }
  h5 {
    color: $b-emph;
    margin: 2rem auto;
    font-size: 24px;
  }
}
</style>
